import { render, staticRenderFns } from "./MyOverlay.vue?vue&type=template&id=2935671c&scoped=true&"
import script from "./MyOverlay.vue?vue&type=script&lang=js&"
export * from "./MyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MyOverlay.vue?vue&type=style&index=0&id=2935671c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935671c",
  null
  
)

export default component.exports